import { useEffect, useState } from "react";
import { api } from "@/api";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";

export default function CorporateInfo() {
  const [company, setCompany] = useState(null);
  useEffect(() => {
    api.get("/company").then((r) => setCompany(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = [
    ["Legal Name", company?.legalName],
    ["Corporate Identification Number", company?.cin],
    ["Incorporation Date", company?.incorporationDate],
    ["Company Type", company?.companyType],
    ["Company Category", company?.companyCategory],
    ["Sub-category", company?.subCategory],
    ["Registrar of Companies", company?.roc],
    ["Corporate Status", company?.status],
    ["Registered State", company?.registeredState],
    ["Country", company?.country],
    ["Registered Office", company?.registeredOffice],
  ].filter(([, v]) => v);

  return (
    <div data-testid="corporate-info-page">
      <PageHero
        eyebrow="Corporate Information"
        title="Statutory & corporate details."
        lede="Official corporate information for Roy Career Solutions Private Limited."
      />

      <section className="py-24 lg:py-32" data-testid="corporate-info-table-section">
        <div className="container-rcs max-w-4xl">
          <Reveal>
            <div className="overflow-hidden rounded-2xl border border-navy-900/10 bg-white" data-testid="corporate-info-table">
              <dl>
                {rows.map(([k, v], i) => (
                  <div key={k} className={`grid gap-1 px-8 py-5 sm:grid-cols-3 sm:gap-6 ${i % 2 === 0 ? "bg-ivory" : "bg-white"}`}>
                    <dt className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{k}</dt>
                    <dd className="text-sm font-semibold text-navy-900 sm:col-span-2">{v}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-10 rounded-2xl border border-gold/40 bg-gold/5 p-6 text-xs leading-relaxed text-slate-600" data-testid="corporate-info-disclaimer">
              Corporate information displayed on this website is provided for general informational purposes.
              Statutory information should be independently verified through the Ministry of Corporate Affairs
              or other applicable regulatory authorities where required.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
